import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=68e48182&scoped=true&"
import script from "./newsInfo.vue?vue&type=script&lang=js&"
export * from "./newsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e48182",
  null
  
)

export default component.exports